import { apiCall } from './apiClient';

// --- Dropdown Master Endpoints ---

// --- Product Codes Endpoints ---

export const postProductcodes = (product_code) =>
  apiCall('/inventory/inven/productcodes', {
    method: 'POST',
    body: JSON.stringify({ product_code })
  });

export const getProductcodes = () =>
  apiCall('/inventory/inven/getallproductcodes');

export const deleteProductcodes = (id) =>
  apiCall(`/inventory/inven/product-codes/${id}`, {
    method: 'DELETE'
  });

// --- Sample Type Endpoints ---

export const postSampleTypes = (sample_type) =>
  apiCall('/inventory/inven/sampletypes', {
    method: 'POST',
    body: JSON.stringify({ sample_type })
  });

export const getSampleTypes = () =>
  apiCall('/inventory/inven/getallsampletypes');

export const deleteSampleTypes = (id) =>
  apiCall(`/inventory/inven/deletesampletypes/${id}`, {
    method: 'DELETE'
  });


  // --- Categories  Endpoints ---

export const postCategories = (category_name) =>
  apiCall('/inventory/inven/categories', {
    method: 'POST',
    body: JSON.stringify({ category_name })
  });

export const getCategories = () =>
  apiCall('/inventory/inven/getAllcategories');

export const deleteCategories = (id) =>
  apiCall(`/inventory/inven/deletecategories/${id}`, {
    method: 'DELETE'
  });


  // --- SubCategories  Endpoints ---

export const postSubCategories = (subcategory_name) =>
  apiCall('/inventory/inven/subcategories', {
    method: 'POST',
    body: JSON.stringify({ subcategory_name })
  });

export const getSubCategories = () =>
  apiCall('/inventory/inven/getallsubcategories');

export const deleteSubCategories = (id) =>
  apiCall(`/inventory/inven/deletesubcategories/${id}`, {
    method: 'DELETE'
  });


  // --- Product Types Endpoints ---

export const postProductTypes = (product_type) =>
  apiCall('/inventory/inven/producttypes', {
    method: 'POST',
    body: JSON.stringify({ product_type })
  });

export const getProductTypes = () =>
  apiCall('/inventory/inven/getAllproducttypes');

export const deleteProductTypes = (id) =>
  apiCall(`/inventory/inven/deleteproducttypes/${id}`, {
    method: 'DELETE'
  });



  